import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { Popup } from '../../interfaces/Popup/Popup';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { ImageColumn } from '../../components/DataTable/ImageColumn';
import { BoolColumn } from '../../components/DataTable/BoolColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { paginateRows } from '../../utils/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';

const columns: TableColumn<Popup>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'title',
    name: 'Başlık',
    accessor: (row) => <TextColumn value={row.title} />,
  },
  {
    id: 'link-url',
    name: 'Link',
    accessor: (row) => <TextColumn value={row.linkUrl} />,
  },
  {
    id: 'image',
    name: 'Resim',
    accessor: (row) => <ImageColumn url={row.image} />,
    align: 'center',
  },
  {
    id: 'max-show-per-user',
    name: 'Gösterim Limiti',
    accessor: (row) => (
      <TextColumn value={row.maxShowPerUser?.toString() ?? ''} />
    ),
  },
  {
    id: 'delay-seconds',
    name: 'Gecikme Süresi',
    accessor: (row) => <TextColumn value={`${row.delaySeconds} saniye`} />,
  },
  {
    id: 'is-active',
    name: 'Durum',
    accessor: (row) => <BoolColumn value={row.isActive} />,
    align: 'center',
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type PopupsTableProps = {
  popups: Popup[];
};

export const PopupsTable = (props: PopupsTableProps) => {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const paginatedRows = useMemo(
    () => paginateRows(props.popups, limit, page),
    [props.popups, limit, page],
  );

  return (
    <DataTable
      columns={columns}
      totalCount={props.popups.length}
      rows={paginatedRows}
      limit={limit}
      setLimit={setLimit}
      page={page}
      setPage={setPage}
      onClick={(popup) => navigate(`/visual/popups/${popup.id}`)}
    />
  );
};
